import React from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import ILWarning from "../../assets/images/il-warning.png";
import ILSuccessOTP from "../../assets/images/il-success-otp.png";
import ILSuccess from "../../assets/images/il-success.png";

// if setting up the CSS is tricky, you can add this to your page somewhere:
// <link rel="stylesheet" href="https://unpkg.com/react-spring-bottom-sheet/dist/style.css" crossorigin="anonymous">
import "react-spring-bottom-sheet/dist/style.css";

const InformationSheet = ({ sheetDetail, setSheetDetail }) => {
  function onDismiss() {
    setSheetDetail({
      ...sheetDetail,
      open: false,
    });
  }

  function IconType() {
    switch (sheetDetail?.icon) {
      case "success":
        return <img src={ILSuccess} className="mx-auto h-32" alt="Success" />;
      case "success-otp":
        return (
          <img src={ILSuccessOTP} className="mx-auto h-32" alt="Success" />
        );
      default:
        return <img src={ILWarning} className="mx-auto h-20" alt="Warning" />;
    }
  }

  return (
    <BottomSheet
      open={sheetDetail.open}
      onDismiss={onDismiss}
      snapPoints={({ minHeight }) => minHeight}
    >
      <div>
        <div className="space-y-4 px-4 pb-8 pt-4">
          <IconType />
          <div className="space-y-1 text-center text-base">
            <strong className="text-lg text-gray-700">
              {sheetDetail.title}
            </strong>
            <p className="text-pretty text-gray-500">{sheetDetail.detail}</p>
          </div>
          <button onClick={onDismiss} className="w-full text-gray-400">
            Close
          </button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default InformationSheet;
